import { Seller } from '@40seas/entities/sellers';
import { z } from 'zod';
import { TenantlessBaseEntity, TenantlessBaseEntitySchema } from './tenantless.base.entity';
import { TimelineValueSchema } from './timeline-value.entity';

export const BaseEntitySchema = TenantlessBaseEntitySchema.extend({
    tenantId: z.string(),
    seller: z
        .string()
        .regex(/^[0-9a-f]{24}$/i)
        .or(z.any())
        .optional(),
    metadata: z.record(z.string().max(20), z.string().max(200).or(z.number())).optional(),
    timeline: z.record(z.string().max(20), TimelineValueSchema).optional(),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// export const WithBaseEntitySchema = <T extends { merge: (a: unknown) => T; strict: (message?: any) => any }>(schema: T): T =>
// schema.merge(BaseEntitySchema);
export const WithBaseEntitySchema = (schema: any): any => schema.merge(BaseEntitySchema);

export interface BaseEntity extends TenantlessBaseEntity {
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}

export const BaseEntityFieldsArray: (keyof BaseEntity)[] = ['id', 'createdAt', 'updatedAt', 'createdBy', 'seller', 'tenantId', 'timeline'];
